export const YOUTUBE = "YouTube";
export const SOUNDCLOUDE = "SoundCloud";
export const SPOTIFY = "Spotify";
